import axios from 'axios';

const regexFileName = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;

export const getFileNameFromContentDisposition = (contentDisposition) => {
  const result = regexFileName.exec(contentDisposition);
  return result && result[1] ? result[1] : 'zenbusiness_checking_account_verification.pdf';
};

export const fetchPDF = async ({ endpoint, customerToken, accessToken }) => {
  const response = await axios.get(endpoint, {
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'customer-token': customerToken,
      'Content-Type': 'application/pdf'
    },
    responseType: 'blob'
  });

  const blob = new Blob([response.data], { type: 'application/octet-stream' });

  const contentDisposition = response.headers['content-disposition'];
  const fileName = getFileNameFromContentDisposition(contentDisposition);
  return { blob, fileName };
};
